import React, { useState, useEffect } from "react";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Edit from "@material-ui/icons/Edit";
import Done from "@material-ui/icons/Done";
import Close from "@material-ui/icons/Close";

import Pagination from '@material-ui/lab/Pagination';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CardMedia from '@material-ui/core/CardMedia';
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import TransferWithinAStationIcon from '@material-ui/icons/TransferWithinAStation';

import ModalDelete from "components/ModalDelete/ModalDelete";
import ModalUpdate from "components/ModalUpdate/ModalUpdate";
import ModalUpdateSell from "components/ModalUpdateSell/ModalUpdateSell";
import ModalDeleteSell from "components/ModalDeleteSell/ModalDeleteSell";
import ModalMessageValidate from "components/ModalMessageValidate/ModalMessageValidate";
import ModalChangeProduct from "components/ModalChangeProduct/ModalChangeProduct";

import api from "assets/services/api.js";
import useAuth from "hooks/useAuth";

import img0 from "assets/img/products/0.png";
import img1 from "assets/img/products/1.png";
import img2 from "assets/img/products/2.png";
import img3 from "assets/img/products/3.png";
import img4 from "assets/img/products/4.png";
import img5 from "assets/img/products/5.png";
import img6 from "assets/img/products/6.png";
import img7 from "assets/img/products/7.png";
import img8 from "assets/img/products/8.png";
import img9 from "assets/img/products/9.png";
import img10 from "assets/img/products/10.png";
import img11 from "assets/img/products/11.png";
import img12 from "assets/img/products/46.png";
import img13 from "assets/img/products/50010.png";
import img14 from "assets/img/products/50012.png";
import img15 from "assets/img/products/50040.png";// requeijão premium 1.5
import img16 from "assets/img/products/50041.png";// cheddar premium 1.5
import img17 from "assets/img/products/180001.png";
import img18 from "assets/img/products/180002.png";


import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { Box, Typography } from "@material-ui/core";
const styles3 = {
  amountbox: {
    fontSize: "14px",
  },
  MT: {
    marginTop: "-13px",
  }
};
const useStyles3 = makeStyles(styles3);
const useStyles2 = makeStyles(styles2);
const useStyles = makeStyles(styles);
const images = [
  img0,
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18
]



export default function Dashboard() {

  const classes = useStyles();
  const classes2 = useStyles2();
  const classes3 = useStyles3();

  const { storageId, garlicType } = useAuth();

  const [storageOfProducts, setStorageOfProducts] = useState([]);
  const [storageOfProductsTotal, setStorageOfProductsTotal] = useState([]);
  const [messageOfStorages, setMessageOfStorages] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [modalShowChange, setModalShowChange] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const [modalShowDelete, setModalShowDelete] = useState(false);
  const [index, setIndex] = useState({ id: 1 });
  const [indexProduct, setIndexProduct] = useState({ id: 1 });

  const [messageOfSells, setMessageOfSells] = useState([]);
  const [pageSell, setPageSell] = useState(1);
  const [totalPagesSell, setTotalPagesSell] = useState(1);

  const [modalShowSell, setModalShowSell] = useState(false);
  const [modalShowDeleteSell, setModalShowSellDelete] = useState(false);
  const [indexSell, setIndexSell] = useState({ id: 1 });

  const [modalShowValidate, setModalShowValidate] = useState(false);
  const [indexValidate, setIndexValidate] = useState({ id: 1 });

  const [totalStorage, setTotalStorage] = useState();

  useEffect(() => {
    getMessagesofStorage();
    getStoragesOfProducts();
    getMessagesofSell();
  }, [garlicType])

  useEffect(() => {
    getMessagesofStorage();
    getStoragesOfProducts();
    getMessagesofSell();
  }, [])

  useEffect(() => {
    getMessagesofStorage();
  }, [page])

  useEffect(() => {
    getMessagesofSell();
  }, [pageSell])

  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleChangeSell = (event, value) => {
    setPageSell(value);
  };

  async function callModal(index) {
    const response = await api.get('/storage/' + index.id_storage)
    setIndex(response.data);
    setModalShow(true);
  }

  async function callModalSell(index) {
    const response = await api.get('/sell/' + index.id_sell)
    setIndexSell(response.data);
    setModalShowSell(true);
  }

  async function callModalDeleteSell(index) {
    const response = await api.get('/sell/' + index.id_sell)
    setIndexSell(response.data);
    setModalShowSellDelete(true);
  }

  async function callModalDelete(index) {
    const response = await api.get('/storage/' + index.id_storage)
    setIndex(response.data);
    setModalShowDelete(true);
  }

  async function getStoragesOfProducts() {
    const response = await api.get(`/product_client/admin/${storageId}?garlic=${garlicType}`);
    setStorageOfProductsTotal(response.data[response.data.length - 1]);
    response.data.pop();
    setStorageOfProducts(response.data);
    let totalstorage = 0;
    for (let i = 0; i < response.data.length; i++) {
      totalstorage = parseFloat(totalstorage) + parseFloat(response.data[i].valueOfStorage);
    }
    setTotalStorage(totalstorage);

  }

  async function getMessagesofStorage() {
    const response = await api.get('/message/storage/' + storageId + '/' + page);
    setTotalPages(response.data[0]);
    setMessageOfStorages(response.data[1]);
  }

  async function getMessagesofSell() {
    const response = await api.get('/message/sell/' + storageId + '/' + pageSell);
    setTotalPagesSell(response.data[0]);
    setMessageOfSells(response.data[1]);
  }
  async function callModalValidate(index) {
    if (index.id_storage) {
      index.type = "storage"
    }
    if (index.id_sell) {
      index.type = "sell"
    }
    setIndexValidate(index);
    setModalShowValidate(true);
  }

  async function callModallChange(index) {
    setIndexProduct(index);
    setModalShowChange(true)
  }
  function getProductImage(code) {
    try {
      return require(`assets/img/products/${code}.png`);
    } catch (err) {
      return require(`assets/img/products/11.png`);
    }
  }
  return (
    <div>
      <GridContainer>
        {storageOfProducts.map(product => (
          <GridItem key={String(product.img)} xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="warning" stats icon>
                <Box sx={{ minHeight: '14em' }}>
                  <CardMedia>
                    <img
                      className={classes.imageDash}
                      src={getProductImage(product.new_code)}
                      title={product.name}
                    />
                  </CardMedia>
                  <Typography variant="h6" style={{}} >{product.name}</Typography>
                  <Box sx={{ marginTop: '1em' }}>
                    <Typography variant="body1" gutterBottom style={{ color: '#559ad8' }}>
                      ATUAL
                    </Typography>
                    <Typography variant="h6" gutterBottom style={{}}>
                      {product.weight !== null ? `${parseFloat(product.weight).toFixed(3)} KG` : `${product.amount} UN`} {"<-->"}  {product.weight !== null ? `${parseFloat(product.box)} KG` : `${parseFloat(product.box)} CX`}
                    </Typography>
                    <Typography variant="body1" gutterBottom style={{ color: '#67a44c' }}>
                      EM ANDAMENTO
                    </Typography>
                    <Typography variant="h6" gutterBottom style={{}}>
                      {product.weight !== null ? `${parseFloat(product.amountWithoutSell).toFixed(3)} KG` : `${(product.amountWithoutSell)} UN`} {"<-->"}  {product.weight !== null ? `${parseFloat(product.boxWithouSell).toFixed(3)} KG` : `${parseFloat(product.boxWithouSell).toFixed(2)} CX`}
                    </Typography>
                  </Box>
                </Box>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Typography variant="body1" gutterBottom style={{ color: 'black' }}>
                    Em estoque {product.valueOfStorage ? product.valueOfStorage.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : <></>}
                  </Typography>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        ))}
        <GridItem key={String(9)} xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardMedia>
                <img
                  className={classes.imageDash}
                  src={images[11]}
                  title={"TODOS OS PRODUTOS"}
                />
              </CardMedia>
              <p className={classes.cardCategory}>RESULTADOS DO ÚLTIMO MÊS</p>
              <h3 className={classes.cardTitle}>
                {storageOfProductsTotal?.percent || '0'}%
              </h3>
              <p className={classes.cardCategory}> <p className={classes3.MT}></p>Valor do estoque:<b className={classes3.amountbox}>R$ {parseFloat(totalStorage).toFixed(2)}</b></p>
              <p className={classes.cardCategory}> <p className={classes3.MT}></p>Valor da remessa:<b className={classes3.amountbox}>R$ {storageOfProductsTotal?.shipping || 0}</b></p>
              <p className={classes.cardCategory}> <p className={classes3.MT}></p>Valor total vendido:<b className={classes3.amountbox}>R$ {storageOfProductsTotal?.total || 0}</b></p>
            </CardHeader>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="warning">
              <h4 className={classes.cardTitleWhite}>Mensagens sobre estoque</h4>
              <p className={classes.cardCategoryWhite}>
                Mensagens sobre erros no estoque
              </p>
            </CardHeader>
            <CardBody>
              {messageOfStorages.map(message => (
                <Table
                  tableHeaderColor="warning"
                  tableHead={["Nota fiscal", "Mensagem", "Ações"]}
                  tableData={[
                    [message.nf, message.text,
                    <div className={classes2.tableActions}>
                      {message.validated ? <div></div> :
                        <Tooltip
                          id="tooltip-top"
                          title="Editar estoque"
                          placement="top"
                          classes={{ tooltip: classes2.tooltip }}
                        >
                          <IconButton
                            aria-label="Edit"
                            className={classes2.tableActionButton}
                            onClick={() => callModal(message)}
                          >
                            <Edit
                              className={
                                classes2.tableActionButtonIcon + " " + classes2.edit
                              }

                            />
                          </IconButton>
                        </Tooltip>
                      }
                      <Tooltip
                        id="tooltip-top"
                        title="Deletar estoque"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                      >
                        <IconButton
                          aria-label="Close"
                          className={classes2.tableActionButton}
                          onClick={() => callModalDelete(message)}
                        >
                          <Close
                            className={
                              classes2.tableActionButtonIcon + " " + classes2.edit
                            }
                          />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        id="tooltip-top"
                        title="Mensagem resolvida"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                      >
                        <IconButton
                          aria-label="Done"
                          className={classes2.tableActionButton}
                          onClick={() => callModalValidate(message)}
                        >
                          <Done
                            className={
                              classes2.tableActionButtonIcon + " " + classes2.edit
                            }

                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                    ],
                  ]}
                />
              ))}
              <Pagination count={totalPages} page={page} onChange={handleChange} />
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Mensagens sobre vendas</h4>
              <p className={classes.cardCategoryWhite}>
                Mensagens sobre erros nas vendas
              </p>
            </CardHeader>
            <CardBody>
              {messageOfSells.map(message => (
                <Table
                  tableHeaderColor="warning"
                  tableHead={["Nota fiscal", "Mensagem", "Ações"]}
                  tableData={[
                    [message.nf, message.text,
                    <div className={classes2.tableActions}>
                      {message.validated ? <div></div> :
                        <Tooltip
                          id="tooltip-top"
                          title="Editar venda"
                          placement="top"
                          classes={{ tooltip: classes2.tooltip }}
                        >
                          <IconButton
                            aria-label="Edit"
                            className={classes2.tableActionButton}
                            onClick={() => callModalSell(message)}
                          >
                            <Edit
                              className={
                                classes2.tableActionButtonIcon + " " + classes2.edit
                              }

                            />
                          </IconButton>
                        </Tooltip>
                      }
                      <Tooltip
                        id="tooltip-top"
                        title="Deletar venda"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                      >
                        <IconButton
                          aria-label="Close"
                          className={classes2.tableActionButton}
                          onClick={() => callModalDeleteSell(message)}
                        >
                          <Close
                            className={
                              classes2.tableActionButtonIcon + " " + classes2.edit
                            }

                          />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        id="tooltip-top"
                        title="Mensagem resolvida"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                      >
                        <IconButton
                          aria-label="Done"
                          className={classes2.tableActionButton}
                          onClick={() => callModalValidate(message)}
                        >
                          <Done
                            className={
                              classes2.tableActionButtonIcon + " " + classes2.edit
                            }

                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                    ],
                  ]}
                />
              ))}
              <Pagination count={totalPagesSell} page={pageSell} onChange={handleChangeSell} />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <ModalUpdate key={String("Up_" + index.id)} props={index} show={modalShow} dashboard={true}
        onHide={() => setModalShow(false)} />
      <ModalDelete key={String("Del_" + index.id)} props={index} show={modalShowDelete} dashboard={true}
        onHide={() => setModalShowDelete(false)} />
      <ModalUpdateSell key={String("UpSel_" + indexSell.id)} props={indexSell} show={modalShowSell} dashboard={true}
        onHide={() => setModalShowSell(false)} />
      <ModalDeleteSell key={String("DelSel_" + indexSell.id)} props={indexSell} show={modalShowDeleteSell} dashboard={true}
        onHide={() => setModalShowSellDelete(false)} />
      <ModalMessageValidate key={String("Mes_" + indexValidate.id)} props={indexValidate} show={modalShowValidate} getMessagesofStorage={getMessagesofStorage} getMessagesofSell={getMessagesofSell}
        onHide={() => setModalShowValidate(false)} />
      <ModalChangeProduct key={String("Prod_" + indexProduct.id)} props={indexProduct} show={modalShowChange} onHide={() => setModalShowChange(false)} getStoragesOfProducts={getStoragesOfProducts} />
    </div>
  );
}
